import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  sendPaymentLink: {
    id: 'towingRecord.end.sendPaymentLink',
    defaultMessage: 'Lähetä maksulinkki',
  },
  markComplete: {
    id: 'towingRecord.end.markComplete',
    defaultMessage: 'Merkitse valmiiksi',
  },
  editWaybill: {
    id: 'towingRecord.end.editWaybill',
    defaultMessage: 'Muokkaa kuormakirjaa',
  },
  paymentLinkAlreadySent: {
    id: 'towingRecord.end.paymentLinkAlreadySent',
    defaultMessage: 'Maksulinkki jo lähetetty',
  },
  cancel_success_message: {
    id: 'towingRecord.cancel.success.notification.message',
    defaultMessage: 'Towing record canceled',
  },
  cancel_success_title: { id: 'towingRecord.cancel.success.notification.title', defaultMessage: 'Success' },
  cancel_error_message: {
    id: 'towingRecord.cancel.error.notification.message',
    defaultMessage: 'Towing record not canceled',
  },
  cancel_error_title: { id: 'towingRecord.cancel.error.notification.title', defaultMessage: 'Error' },
  moveToBilling: {
    id: 'towingRecord.end.moveToBilling',
    defaultMessage: 'Siirrä laskutettavaksi',
  },
  markCardPayment: {
    id: 'towingRecord.end.markCardPayment',
    defaultMessage: 'Merkitse korttimaksuksi',
  },
  markCashPayment: {
    id: 'towingRecord.end.markCashPayment',
    defaultMessage: 'Merkitse käteismaksuksi',
  },
  deleteWaybill: {
    id: 'towingRecord.end.deleteWaybill',
    defaultMessage: 'Poista kuormakirja',
  },
  cancelJobHeader: {
    id: 'towingRecord.end.cancelJobHeader',
    defaultMessage: 'Peruuta työ',
  },
  jobEndedAtLabel: {
    id: 'towingRecord.end.jobEndedAtLabel',
    defaultMessage: 'Työ lopetettu',
  },
  selectActionTitle: {
    id: 'towingRecord.end.selectActionTitle',
    defaultMessage: 'Valitse toiminto',
  },
  selectActionMessage: {
    id: 'towingRecord.end.selectActionMessage',
    defaultMessage: 'valitse miten haluat lopettaa työn',
  },
})
